// extracted by mini-css-extract-plugin
export default {"starWrapper":"StarRating_starWrapper__MDR49","star":"StarRating_star__pOoyo","activeStar":"StarRating_activeStar__AU9Ss"};